import { render, staticRenderFns } from "./CoachDetailBody.vue?vue&type=template&id=283eb26e&scoped=true&lang=pug"
import script from "./CoachDetailBody.vue?vue&type=script&lang=js"
export * from "./CoachDetailBody.vue?vue&type=script&lang=js"
import style0 from "./CoachDetailBody.vue?vue&type=style&index=0&id=283eb26e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283eb26e",
  null
  
)

export default component.exports